import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SendbirdChat, { UserEventHandler } from '@sendbird/chat'
import log from 'sentry/log'
import { setUnreadMessageCount } from 'reduxBits/chat/actions'

const UnreadMessages = () => {
  const sb = SendbirdChat.instance
  const currentSbUser = useSelector((state) => state.chat.sendbirdUser)
  const { userId } = currentSbUser
  const dispatch = useDispatch()

  const addUserEventHandlers = useCallback(() => {
    const userEventHandler = new UserEventHandler({
      onTotalUnreadMessageCountChanged: (totalCount) => {
        dispatch(setUnreadMessageCount(totalCount.groupChannelCount))
      },
    })
    sb.addUserEventHandler(userId, userEventHandler)
  }, [userId, dispatch, sb])

  const removeUserEventHandler = useCallback(() => {
    if (sb) {
      sb.removeUserEventHandler(userId)
    }
  }, [userId, sb])

  const getUnreadMessageCount = useCallback(() => {
    sb.groupChannel
      .getTotalUnreadMessageCount()
      .then((totalCount) => {
        dispatch(setUnreadMessageCount(totalCount))
      })
      .catch((error) => {
        log.message(`Chat: error receiving unread messages from sendbird, ${error}`)
      })
  }, [dispatch, sb])

  useEffect(() => {
    if (sb && userId) {
      addUserEventHandlers()
    }
    return () => {
      if (sb && userId) {
        removeUserEventHandler()
      }
    }
  }, [userId, addUserEventHandlers, removeUserEventHandler, sb])

  useEffect(() => {
    if (sb && userId) {
      getUnreadMessageCount()
    }
  }, [getUnreadMessageCount, userId, sb])

  return null
}

export default UnreadMessages
